import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import VerificationForm from "./main_page";
import Admin from "./pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          {/* Default page */}
          <Route path="/" element={<VerificationForm />} />

          {/* Unique hidden admin page */}
          <Route path="/falcon-control-1411-admin" element={<Admin />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;